import React from "react";
import "./Page.scoped.scss";
import PageLeft from "./pageLeft/PageLeft";
import PageRight from "./pageRight/PageRight";
import { useRecoilValue } from "recoil";
import { isMobileMatcheState } from "../../../atoms/atom";
import { IPageHeaderShowProps } from "../../../views/Main";

function Page(props: IPageHeaderShowProps) {
  const { len } = props;
  const isMobile = useRecoilValue(isMobileMatcheState);

  return (
    <section className={!isMobile ? "page" : ""}>
      {!isMobile ? (
        <div className={`page-body ${len}`}>
          <div className="row-w clearfix">
            <PageLeft len={len} />
            <PageRight len={len} />
          </div>
        </div>
      ) : (
        <>
          <PageLeft />
          <PageRight />

        </>
      )}
    </section>
  );
}

export default Page;
